<template>
  <article class="message is-warning">
    <div class="message-header">
      <p>{{ $texts('userImageRequired', 'Benutzerbild erforderlich') }}</p>
    </div>
    <div class="message-body">
      <p class="mb-4">
        {{
          $texts(
            'uploadImageRequired',
            'Um den Gutschein zu drucken, müssen Sie ein persönliches Benutzerbild hochladen.',
          )
        }}
      </p>
      <VuepalLink
        :to="pictureDestination"
        class="button is-normal is-fullwidth mb-2"
        >{{ $texts('uploadUserImage', 'Benutzerbild hochladen') }}</VuepalLink
      >
    </div>
  </article>
</template>

<script setup lang="ts">
const user = useDrupalUser()
const { $texts } = useNuxtApp()

const pictureDestination = computed(() => {
  if (user.value.loggedIn) {
    return '/user/' + user.value.uid + '?tab=image'
  }
  return '/user'
})
</script>
